"use client";
import { Box, Stack, SimpleGrid, GridItem, List } from "@chakra-ui/react";
import Link from "next/link";
import { FaRegEye } from "@onemind-services-llc/react-icons-ng/fa";
import { DefaultHoverEffect } from "styles/hoverPresets";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PageLayout from "@/layouts/pageLayout";
import { Heading, Text, Button } from "@/elements";
import { pdfLinks } from "./constants";

const SecurityAssessmentsPage = () => {
  const HeadingVariant = useHeadingVariant();

  return (
    <Box id="sec-assessments" bgColor={"#EDF2F7"} py={12} mt={12}>
      <PageLayout marginTop={0} spacing={8}>
        <Heading variant={HeadingVariant} mb={12} textAlign={"center"}>
          Explore Our Security Assessment Offerings
        </Heading>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={{ base: 8, lg: 16 }}>
          {pdfLinks.map((pdf) => (
            <GridItem
              key={pdf.label}
              role="group"
              boxShadow={"xl"}
              p={6}
              bgColor={"white"}
              borderRadius="lg"
              _hover={DefaultHoverEffect}
            >
              <Stack justifyContent="space-between" h="100%">
                <Text
                  variant={"label1"}
                  color="primary.200"
                  _groupHover={{
                    color: "white",
                  }}
                  mb={4}
                  fontWeight={550}
                >
                  {pdf.label}
                </Text>
                <Text variant={"body2"} color="text.100" _groupHover={{ color: "white" }}>
                  {pdf.desc}
                </Text>
                <List.Root mb={4} color="text.100" _groupHover={{ color: "white" }}>
                  {pdf.bullets.map((bullet, index) => (
                    <List.Item key={index}>
                      <Text as="span" variant={"body2"} fontWeight={550}>
                        {bullet.label} :{" "}
                      </Text>
                      <Text as="span" variant={"body2"} fontWeight={400}>
                        {bullet.desc}
                      </Text>
                    </List.Item>
                  ))}
                </List.Root>
                <Button
                  as={Link}
                  href={pdf.src}
                  target="_blank"
                  rel="noopener noreferrer"
                  bg="gray.100"
                  color="primary.200"
                  border="none"
                  borderRadius="32px"
                  _hover={{
                    bg: "white",
                    color: "black",
                  }}
                  w="fit-content"
                  fontSize="20px"
                  fontWeight={500}
                >
                  <FaRegEye />
                  Preview
                </Button>
              </Stack>
            </GridItem>
          ))}
        </SimpleGrid>
      </PageLayout>
    </Box>
  );
};

export default SecurityAssessmentsPage;
